export default {
    materials: [],
    materialsPmsTypes: [],
    materialsLoading: false,
    unitsOfMeasure: [],
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters,
    materialTypes: [],
    uploadCancelTokens: []
}

function setInitialFilters() {
    return {
        name: null,
        materialIndex : null,
        isVisible: true,
    }
}